// Auth action type
export const AUTH_STATE_CHANGED = 'AUTH_STATE_CHANGED';
export const USER_DATA_INIT = 'USER_DATA_INIT';
export const AUTH_ERROR_MSG = 'AUTH_ERROR_MSG';
export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const AUTH_INIT = 'AUTH_INIT';
export const CLEAR_USER_AUTH = 'CLEAR_USER_AUTH';
export const GET_EMPRESA_INIT = 'GET_EMPRESA_INIT';
export const GET_EMPRESA_SUCCESS = 'GET_EMPRESA_SUCCESS';
export const SET_EMPRESA = 'SET_EMPRESA';
export const GET_PAINEIS_EMPRESA_INIT = 'GET_PAINEIS_EMPRESA_INIT';
export const GET_PAINEIS_EMPRESA_SUCCESS = 'GET_PAINEIS_EMPRESA_SUCCESS';
export const CLEAR_LIST_PAINEIS_EMP = 'CLEAR_LIST_PAINEIS_EMP';
export const GET_PAINEIS_USUARIO_INIT = 'GET_PAINEIS_USUARIO_INIT';
export const GET_PAINEIS_USUARIO_SUCCESS = 'GET_PAINEIS_USUARIO_SUCCESS';

// Users action Type ----------------------------------------------
export const USERS_FETCH_DATA_INIT = 'USERS_FETCH_DATA_INIT';
export const USERS_FETCH_DATA_SUCCESS = 'USERS_FETCH_DATA_SUCCESS';
export const USERS_DELETE_USER_INIT = 'USERS_DELETE_USER_INIT';
export const USERS_DELETE_USER_SUCCESS = 'USERS_DELETE_USER_SUCCESS';
export const USERS_CREATE_USER_INIT = 'USERS_CREATE_USER_INIT';
export const USERS_CREATE_USER_SUCCESS = 'USERS_CREATE_USER_SUCCESS';
export const USERS_MODIFY_USER_INIT = 'USERS_MODIFY_USER_INIT';
export const USERS_MODIFY_USER_SUCCESS = 'USERS_MODIFY_USER_SUCCESS';
export const USERS_CLEAN_UP = 'USERS_CLEAN_UP';
export const USERS_CLEAR_DATA_LOGOUT = 'USERS_CLEAR_DATA_LOGOUT';
export const ATRIBUIR_EMPRESA_INIT = 'ATRIBUIR_EMPRESA_INIT';
export const ATRIBUIR_EMPRESA_SUCCESS = 'ATRIBUIR_EMPRESA_SUCCESS';
export const USER_SEND_EMAIL_INIT = 'USER_SEND_EMAIL_INIT';
export const USER_SEND_EMAIL_SUCCESS = 'USER_SEND_EMAIL_SUCCESS';
export const USERS_ERROR_MSG = 'USERS_ERROR_MSG';

// Paineis -------------------------------------------------------
export const CREATE_PAINEL_INIT = 'CREATE_PAINEL_INIT';
export const CREATE_PAINEL_SUCCESS = 'CREATE_PAINEL_SUCCESS';
export const MODIFY_PAINEL_INIT = 'MODIFY_PAINEL_INIT';
export const MODIFY_PAINEL_SUCCESS = 'MODIFY_PAINEL_SUCCESS';
export const DELETE_PAINEL_INIT = 'DELETE_PAINEL_INIT';
export const DELETE_PAINEL_SUCCESS = 'DELETE_PAINEL_SUCCESS';
export const LIST_PAINEL_INIT = 'LIST_PAINEL_INIT';
export const LIST_PAINEL_SUCCESS = 'LIST_PAINEL_SUCCESS';
export const PAINEIS_ERROR_MSG = 'PAINEIS_ERROR_MSG';
export const PAINEIS_CLEAN_UP = 'PAINEIS_CLEAN_UP';

// Empresas action types ------------------------------------------------
export const DELETE_EMPRESA_INIT = 'DELETE_EMPRESA_INIT';
export const DELETE_EMPRESA_SUCCESS = 'DELETE_EMPRESA_SUCCESS';
export const LIST_EMPRESA_INIT = 'LIST_EMPRESA_INIT';
export const LIST_EMPRESA_SUCCESS = 'LIST_EMPRESA_SUCCESS';
export const MODIFY_EMPRESA_INIT = 'MODIFY_EMPRESA_INIT';
export const MODIFY_EMPRESA_SUCCESS = 'MODIFY_EMPRESA_SUCCESS';
export const CREATE_EMPRESA_INIT = 'CREATE_EMPRESA_INIT';
export const CREATE_EMPRESA_SUCCESS = 'CREATE_EMPRESA_SUCCESS';
export const EMPRESA_ERROR_MSG = 'EMPRESA_ERROR_MSG';
export const EMPRESA_CLEAN_UP = 'EMPRESA_CLEAN_UP';
export const ATRIBUIR_PAINEIS_EMPRESA_INIT = 'ATRIBUIR_PAINEIS_EMPRESA_INIT';
export const ATRIBUIR_PAINEIS_EMPRESA_SUCCESS = 'ATRIBUIR_PAINEIS_EMPRESA_SUCCESS';
export const EMPRESA_CLEAN_LIST_EMPS = 'EMPRESA_CLEAN_LIST_EMPS';

// Logs -------------------------------------------------------------------
export const SEND_LOG = 'SEND_LOG';
export const LOG_ERROR_MSG = 'LOG_ERROR_MSG';

// Paineis Users ----------------------------------------------------------------
export const ATRIBUI_PAINEIS_USUARIO_INIT = 'ATRIBUI_PAINEIS_USUARIO_INIT';
export const ATRIBUI_PAINEIS_USUARIO_SUCCESS = 'ATRIBUI_PAINEIS_USUARIO_SUCCESS';
export const DESATRIBUI_PAINEIS_USUARIO_INIT = 'DESATRIBUI_PAINEIS_USUARIO_INIT';
export const DESATRIBUI_PAINEIS_USUARIO_SUCCESS = 'DESATRIBUI_PAINEIS_USUARIO_SUCCESS';
export const PAINEL_USER_ERROR_MSG = 'PAINEL_USER_ERROR_MSG';
export const PAINEL_USER_CLEAN_UP = 'PAINEL_USER_CLEAN_UP';

// Metas -------------------------------------------------------------------
export const CREATE_METAS_INIT = 'CREATE_METAS_INIT';
export const CREATE_METAS_SUCCESS = 'CREATE_METAS_SUCCESS';
export const METAS_ERROR_MSG = 'METAS_ERROR_MSG';
export const CLEAR_METAS = 'CLEAR_METAS';
export const UPDATE_META_INIT = 'UPDATE_META_INIT';
export const UPDATE_META_SUCCESS = 'UPDATE_META_SUCCESS';
export const META_LIST_METAS_INIT = 'META_LIST_METAS_INIT';
export const META_LIST_METAS_SUCCESS = 'META_LIST_METAS_SUCCESS';
export const META_DELETE_META_INIT = 'META_DELETE_META_INIT';
export const META_DELETE_META_SUCCESS = 'META_DELETE_META_SUCCESS';
export const META_OBTEM_META_INIT = 'META_OBTEM_META_INIT';
export const META_OBTEM_META_SUCCESS = 'META_OBTEM_META_SUCCESS';

// Colaboradores -------------------------------------------------------------------
export const LIST_COLABORADOR_INIT = 'LIST_COLABORADOR_INIT';
export const LIST_COLABORADOR_SUCCESS = 'LIST_COLABORADOR_SUCCESS';
export const CREATE_COLABORADOR_INIT = 'CREATE_COLABORADOR_INIT';
export const CREATE_COLABORADOR_SUCCESS = 'CREATE_COLABORADOR_SUCCESS';
export const EDIT_COLABORADOR_INIT = 'EDIT_COLABORADOR_INIT';
export const EDIT_COLABORADOR_SUCCESS = 'EDIT_COLABORADOR_SUCCESS';
export const CLEAR_COLABORADORES = 'CLEAR_COLABORADORES';
export const COLABORADORES_ERRO_MSG = 'COLABORADORES_ERRO_MSG';

// Grupo de controle--------------------------------------------------------------------
export const LIST_GRUPO_CONTROLE_INIT = 'LIST_GRUPO_CONTROLE_INIT';
export const LIST_GRUPO_CONTROLE_SUCCESS = 'LIST_GRUPO_CONTROLE_SUCCESS';
export const CREATE_GRUPO_CONTROLE_INIT = 'CREATE_GRUPO_CONTROLE_INIT';
export const CREATE_GRUPO_CONTROLE_SUCCESS = 'CREATE_GRUPO_CONTROLE_SUCCESS';
export const UPDATE_GRUPO_CONTROLE_INIT = 'UPDATE_GRUPO_CONTROLE_INIT';
export const UPDATE_GRUPO_CONTROLE_SUCCESS = 'UPDATE_GRUPO_CONTROLE_SUCCESS';
export const DELETE_GRUPO_CONTROLE_INIT = 'DELETE_GRUPO_CONTROLE_INIT';
export const DELETE_GRUPO_CONTROLE_SUCCESS = 'DELETE_GRUPO_CONTROLE_SUCCESS';
export const CLEAR_GRUPO_CONTROLE = 'CLEAR_GRUPO_CONTROLE';
export const ERROR_GRUPO_CONTROLE_MSG = 'ERROR_GRUPO_CONTROLE_MSG';

// Fator --------------------------------------------------------------------
export const CREATE_FATOR_INIT = 'CREATE_FATOR_INIT';
export const CREATE_FATOR_SUCCESS = 'CREATE_FATOR_SUCCESS';
export const FATOR_ERROR_MSG = 'FATOR_ERROR_MSG';
export const CLEAR_FATOR = 'CLEAR_FATOR';
export const UPDATE_FATOR_INIT = 'UPDATE_FATOR_INIT';
export const UPDATE_FATOR_SUCCESS = 'UPDATE_FATOR_SUCCESS';
export const DELETE_FATOR_INIT = 'DELETE_FATOR_INIT';
export const DELETE_FATOR_SUCCESS = 'DELETE_FATOR_SUCCESS';
export const FATOR_LIST_FATORES_EMPRESA_INIT = 'FATOR_LIST_FATORES_EMPRESA_INIT';
export const FATOR_LIST_FATORES_EMPRESA_SUCCESS = 'FATOR_LIST_FATORES_EMPRESA_SUCCESS';
export const FATOR_OBTEM_FATOR_INIT = 'FATOR_OBTEM_FATOR_INIT';
export const FATOR_OBTEM_FATOR_SUCCESS = 'FATOR_OBTEM_FATOR_SUCCESS';

// Campanha ----------------------------------------------------------------
export const CREATE_CAMPANHA_INIT = 'CREATE_CAMPANHA_INIT';
export const CREATE_CAMPANHA_SUCCESS = 'CREATE_CAMPANHA_SUCCESS';
export const CAMPANHA_ERROR_MSG = 'CAMPANHA_ERROR_MSG';
export const CLEAR_CAMPANHA = 'CLEAR_CAMPANHA';
export const UPDATE_CAMPANHA_INIT = 'UPDATE_CAMPANHA_INIT';
export const UPDATE_CAMPANHA_SUCCESS = 'UPDATE_CAMPANHA_SUCCESS';
export const DUPLICATE_CAMPANHA_INIT = 'DUPLICATE_CAMPANHA_INIT';
export const DUPLICATE_CAMPANHA_SUCCESS = 'DUPLICATE_CAMPANHA_SUCCESS';
export const CAMPANHA_LIST_CAMPANHA_INIT = 'CAMPANHA_LIST_CAMPANHA_INIT';
export const CAMPANHA_LIST_CAMPANHA_SUCCESS = 'CAMPANHA_LIST_CAMPANHA_SUCCESS';
export const CAMPANHA_DELETE_CAMPANHA_INIT = 'CAMPANHA_DELETE_CAMPANHA_INIT';
export const CAMPANHA_DELETE_CAMPANHA_SUCCESS = 'CAMPANHA_DELETE_CAMPANHA_SUCCESS';
export const CAMPANHA_OBTEM_CAMPANHA_INIT = 'CAMPANHA_OBTEM_CAMPANHA_INIT';
export const CAMPANHA_OBTEM_CAMPANHA_SUCCESS = 'CAMPANHA_OBTEM_CAMPANHA_SUCCESS';

// Excesso Estoque ----------------------------------------------------------------
export const CLEAR_FLAGS_ESTOQUE = 'CLEAR_FLAGS_ESTOQUE';
export const SET_ESTOQUE_DADOS_INIT = 'SET_ESTOQUE_DADOS_INIT';
export const SET_ESTOQUE_DADOS_SUCCESS = 'SET_ESTOQUE_DADOS_SUCCESS';
export const ERROR_ESTOQUE_MSG = 'ERROR_ESTOQUE_MSG';

// Curva_ABC ----------------------------------------------------------------
export const CLEAR_FLAGS_CURVA = 'CLEAR_FLAGS_CURVA';
export const SET_CURVA_ABC_INIT = 'SET_CURVA_ABC_INIT';
export const SET_CURVA_ABC_SUCCESS = 'SET_CURVA_ABC_SUCCESS';
export const ERROR_CURVA_MSG = 'ERROR_CURVA_MSG';

// Categorias action types -----------------------------------------------------------
export const LIST_CATEGORIA_INIT = 'LIST_CATEGORIA_INIT';
export const LIST_CATEGORIA_SUCCESS = 'LIST_CATEGORIA_SUCCESS';
export const CREATE_CATEGORIA_INIT = 'CREATE_CATEGORIA_PAINEL_INIT';
export const CREATE_CATEGORIA_SUCCESS = 'CREATE_CATEGORIA_SUCCESS';
export const UPDATE_CATEGORIA_INIT = 'UPDATE_CATEGORIA_INIT';
export const UPDATE_CATEGORIA_SUCCESS = 'UPDATE_CATEGORIA_SUCCESS';
export const DELETE_CATEGORIA_INIT = 'DELETE_CATEGORIA_INIT';
export const DELETE_CATEGORIA_SUCCESS = 'DELETE_CATEGORIA_SUCCESS';
export const CATEGORIA_ERROR_MSG = 'CATEGORIA_ERROR_MSG';
export const CLEAR_CATEGORIA = 'CLEAR_CATEGORIA';

// Parametros Integracao ----------------------------------------------------------------
export const GET_PARAMETROS_INTEGRACAO_INIT = 'GET_PARAMETROS_INTEGRACAO_INIT';
export const GET_PARAMETROS_INTEGRACAO_SUCCESS = 'GET_PARAMETROS_INTEGRACAO_SUCCESS';
export const UPDATE_PARAMETROS_INTEGRACAO_INIT = 'UPDATE_PARAMETROS_INTEGRACAO_INIT';
export const UPDATE_PARAMETROS_INTEGRACAO_SUCCESS = 'UPDATE_PARAMETROS_INTEGRACAO_SUCCESS';
export const VALIDAR_DADOS_PGLOADER_INIT = 'VALIDAR_DADOS_PGLOADER_INIT';
export const VALIDAR_DADOS_PGLOADER_SUCCESS = 'VALIDAR_DADOS_PGLOADER_SUCCESS';
export const CLEAR_FLAGS_PARAMETROS_INTEGRACAO = 'CLEAR_FLAGS_PARAMETROS_INTEGRACAO';
export const ERROR_PARAMETROS_INTEGRACAO_MSG = 'ERROR_PARAMETROS_INTEGRACAO_MSG';

// Parametros Embedded Bi ----------------------------------------------------------------
export const CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI = 'CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI';
export const SET_PARAMETROS_EMBEDDED_BI_INIT = 'SET_PARAMETROS_EMBEDDED_BI_INIT';
export const SET_PARAMETROS_EMBEDDED_BI_SUCCESS = 'SET_PARAMETROS_EMBEDDED_BI_SUCCESS';
export const ERROR_PARAMETROS_EMBEDDED_BI_MSG = 'ERROR_PARAMETROS_EMBEDDED_BI_MSG';
export const CRIAR_WORKSPACE_INIT = 'CRIAR_WORKSPACE_INIT';
export const SET_ARQUITETURA_PBI_ATIVA_INIT = 'SET_ARQUITETURA_PBI_ATIVA_INIT';
export const SET_ARQUITETURA_PBI_ATIVA_SUCCESS = 'SET_ARQUITETURA_PBI_ATIVA_SUCCESS';
export const ERROR_ARQUITETURA_PBI_ATIVA_MSG = 'ERROR_ARQUITETURA_PBI_ATIVA_MSG';
export const ATUALIZAR_WORKSPACE_INIT = 'ATUALIZAR_WORKSPACE_INIT';
export const CRIAR_NOVA_VERSAO_WORKSPACE_INIT = 'CRIAR_NOVA_VERSAO_WORKSPACE_INIT';

// Definições PBI / Versões PBI -----------------------------------------------------------
export const GET_VERSOES_PBI_INIT = 'GET_VERSOES_PBI_INIT';
export const GET_VERSOES_PBI_SUCCESS = 'GET_VERSOES_PBI_SUCCESS';
export const UPDATE_STATUS_VERSAO_PBI_INIT = 'UPDATE_STATUS_VERSAO_PBI_INIT';
export const UPDATE_STATUS_VERSAO_PBI_SUCCESS = 'UPDATE_STATUS_VERSAO_PBI_SUCCESS';
export const ERROR_DEFINICOES_PBI_MSG = 'ERROR_DEFINICOES_PBI_MSG';
export const CLEAR_FLAGS_DEFINICOES_PBI = 'CLEAR_FLAGS_DEFINICOES_PBI';

// PowerBI Workspace action types -----------------------------------------------------------
export const POWERBI_WORKSPACE_PROGRESS = 'POWERBI_WORKSPACE_PROGRESS';
export const POWERBI_WORKSPACE_SUCCESS = 'POWERBI_WORKSPACE_SUCCESS';
export const POWERBI_WORKSPACE_ERROR = 'POWERBI_WORKSPACE_ERROR';

// Classificacoes action types -----------------------------------------------------------
export const LIST_CLASSIFICACAO_INIT = 'LIST_CLASSIFICACAO_INIT';
export const LIST_CLASSIFICACAO_SUCCESS = 'LIST_CLASSIFICACAO_SUCCESS';
export const CREATE_CLASSIFICACAO_INIT = 'CREATE_CLASSIFICACAO_INIT';
export const CREATE_CLASSIFICACAO_SUCCESS = 'CREATE_CLASSIFICACAO_SUCCESS';
export const UPDATE_CLASSIFICACAO_INIT = 'UPDATE_CLASSIFICACAO_INIT';
export const UPDATE_CLASSIFICACAO_SUCCESS = 'UPDATE_CLASSIFICACAO_SUCCESS';
export const DELETE_CLASSIFICACAO_INIT = 'DELETE_CLASSIFICACAO_INIT';
export const DELETE_CLASSIFICACAO_SUCCESS = 'DELETE_CLASSIFICACAO_SUCCESS';
export const CLASSIFICACAO_ERROR_MSG = 'CLASSIFICACAO_ERROR_MSG';
export const CLEAR_CLASSIFICACAO = 'CLEAR_CLASSIFICACAO';

// Motivos action types -----------------------------------------------------------
export const LIST_MOTIVO_INIT = 'LIST_MOTIVO_INIT';
export const LIST_MOTIVO_SUCCESS = 'LIST_MOTIVO_SUCCESS';
export const CREATE_MOTIVO_INIT = 'CREATE_MOTIVO_PAINEL_INIT';
export const CREATE_MOTIVO_SUCCESS = 'CREATE_MOTIVO_SUCCESS';
export const UPDATE_MOTIVO_INIT = 'UPDATE_MOTIVO_INIT';
export const UPDATE_MOTIVO_SUCCESS = 'UPDATE_MOTIVO_SUCCESS';
export const DELETE_MOTIVO_INIT = 'DELETE_MOTIVO_INIT';
export const DELETE_MOTIVO_SUCCESS = 'DELETE_MOTIVO_SUCCESS';
export const MOTIVO_ERROR_MSG = 'MOTIVO_ERROR_MSG';
export const CLEAR_MOTIVO = 'CLEAR_MOTIVO';

// Paramêtros Locais action types -----------------------------------------------------------
export const GET_PARAMETROS_LOCAIS_INIT = 'GET_PARAMETROS_LOCAIS_INIT';
export const GET_PARAMETROS_LOCAIS_SUCCESS = 'GET_PARAMETROS_LOCAIS_SUCCESS';
export const UPDATE_PARAMETROS_LOCAIS_INIT = 'UPDATE_PARAMETROS_LOCAIS_INIT';
export const UPDATE_PARAMETROS_LOCAIS_SUCCESS = 'UPDATE_PARAMETROS_LOCAIS_SUCCESS';
export const PARAMETROS_LOCAIS_ERROR_MSG = 'PARAMETROS_LOCAIS_ERROR_MSG';
export const CLEAR_PARAMETROS_LOCAIS = 'CLEAR_PARAMETROS_LOCAIS';

// Paramêtros Globais action types -----------------------------------------------------------
export const GET_PARAMETROS_GLOBAIS_INIT = 'GET_PARAMETROS_GLOBAIS_INIT';
export const GET_PARAMETROS_GLOBAIS_SUCCESS = 'GET_PARAMETROS_GLOBAIS_SUCCESS';
export const UPDATE_PARAMETROS_GLOBAIS_INIT = 'UPDATE_PARAMETROS_GLOBAIS_INIT';
export const UPDATE_PARAMETROS_GLOBAIS_SUCCESS = 'UPDATE_PARAMETROS_GLOBAIS_SUCCESS';
export const PARAMETROS_GLOBAIS_ERROR_MSG = 'PARAMETROS_GLOBAIS_ERROR_MSG';
export const CLEAR_PARAMETROS_GLOBAIS = 'CLEAR_PARAMETROS_GLOBAIS';

// Buscar dados Externos -----------------------------------------------------------
export const GET_DADOS_CNPJ_INIT = 'GET_DADOS_CNPJ_INIT';
export const GET_DADOS_CNPJ_SUCCESS = 'GET_DADOS_CNPJ_SUCCESS';
export const DADOS_EXTERNOS_CLEAN_UP = 'DADOS_EXTERNOS_CLEAN_UP';
export const ERROR_DADOS_EXTERNOS_MSG = 'ERROR_DADOS_EXTERNOS_MSG';

// Construtor relatorios ----------------------------------------------------------------------------
export const GET_TABELAS_RELATORIOS_INIT = 'GET_TABELAS_RELATORIOS_INIT';
export const GET_TABELAS_RELATORIOS_SUCCESS = 'GET_TABELAS_RELATORIOS_SUCCESS';
export const POST_EXECUTA_CONSULTA_RELATORIO_INIT = 'POST_EXECUTA_CONSULTA_RELATORIO_INIT';
export const POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS = 'POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS';
export const CREATE_RELATORIO_INIT = 'CREATE_RELATORIO_INIT';
export const CREATE_RELATORIO_SUCCESS = 'CREATE_RELATORIO_SUCCESS';
export const UPDATE_RELATORIO_INIT = 'UPDATE_RELATORIO_INIT';
export const UPDATE_RELATORIO_SUCCESS = 'UPDATE_RELATORIO_SUCCESS';
export const DELETE_RELATORIO_INIT = 'DELETE_RELATORIO_INIT';
export const DELETE_RELATORIO_SUCCESS = 'DELETE_RELATORIO_SUCCESS';
export const CONSTRUTOR_CONSULTA_NAO_ENCONTRADA = 'CONSTRUTOR_CONSULTA_NAO_ENCONTRADA';
export const CONSTRUTOR_CLEAN_UP = 'CONSTRUTOR_CLEAN_UP';
export const ERROR_CONSTRUTOR_MSG = 'ERROR_RELATORIOS_MSG';

// CloudFlare -----------------------------------------------------------
export const CREATE_TUNNEL_NAME_INIT = 'CREATE_TUNNEL_NAME_INIT';
export const CREATE_TUNNEL_NAME_SUCCESS = 'CREATE_TUNNEL_NAME_SUCCESS';
export const ERROR_CLOUDFLARE_TUNEL = 'ERROR_CLOUDFLARE_TUNEL';
export const CLEAR_CLOUDFLARE_TUNEL = 'CLEAR_CLOUDFLARE_TUNEL';
export const REFRESH_TUNNEL_INIT = 'REFRESH_TUNNEL_INIT';
export const REFRESH_TUNNEL_SUCCESS = 'REFRESH_TUNNEL_SUCCESS';
export const VALIDATE_CONNECTOR_INIT = 'VALIDATE_CONNECTOR_INIT';
export const VALIDATE_CONNECTOR_SUCCESS = 'VALIDATE_CONNECTOR_SUCCESS';
export const DELETE_TUNNEL_INIT = 'DELETE_TUNNEL_INIT';
export const DELETE_TUNNEL_SUCCESS = 'DELETE_TUNNEL_SUCCESS';
export const CONFIGURE_ROTA_TUNNEL_INIT = 'CONFIGURE_ROTA_TUNNEL_INIT';
export const CONFIGURE_ROTA_TUNNEL_SUCCESS = 'CONFIGURE_ROTA_TUNNEL_SUCCESS';
export const UPDATE_ETAPAS_TUNNEL_INIT = 'UPDATE_ETAPAS_TUNNEL_INIT';
export const UPDATE_ETAPAS_TUNNEL_SUCCESS = 'UPDATE_ETAPAS_TUNNEL_SUCCESS';

// Machines -----------------------------------------------------------
export const GET_MACHINE_INIT = 'GET_MACHINE_INIT';
export const GET_MACHINE_SUCCESS = 'GET_MACHINE_SUCCESS';
export const CREATE_MACHINE_INIT = 'CREATE_MACHINE_INIT';
export const CREATE_MACHINE_SUCCESS = 'CREATE_MACHINE_SUCCESS';
export const SEND_COMAND_MACHINE_INIT = 'SEND_COMAND_MACHINE_INIT';
export const SEND_COMAND_MACHINE_SUCCESS = 'SEND_COMAND_MACHINE_SUCCESS';
export const DELETE_MACHINE_INIT = 'DELETE_MACHINE_INIT';
export const DELETE_MACHINE_SUCCESS = 'DELETE_MACHINE_SUCCESS';
export const CONGELAR_MACHINE_INIT = 'CONGELAR_MACHINE_INIT';
export const CONGELAR_MACHINE_SUCCESS = 'CONGELAR_MACHINE_SUCCESS';
export const ERROR_MACHINE = 'ERROR_MACHINE';
export const CLEAR_MACHINE = 'CLEAR_MACHINE';
export const CLEAR_MACHINE_FLAGS = 'CLEAR_MACHINE_FLAGS';

// Shedules -----------------------------------------------------------
export const LIST_SHEDULE_INIT = 'LIST_SHEDULE_INIT';
export const LIST_SHEDULE_SUCCESS = 'LIST_SHEDULE_SUCCESS';
export const CREATE_SHEDULE_INIT = 'CREATE_SHEDULE_INIT';
export const CREATE_SHEDULE_SUCCESS = 'CREATE_SHEDULE_SUCCESS';
export const UPDATE_SHEDULE_INIT = 'UPDATE_SHEDULE_INIT';
export const UPDATE_SHEDULE_SUCCESS = 'UPDATE_SHEDULE_SUCCESS';
export const DELETE_SHEDULE_INIT = 'DELETE_SHEDULE_INIT';
export const DELETE_SHEDULE_SUCCESS = 'DELETE_SHEDULE_SUCCESS';
export const ERROR_SHEDULE = 'ERROR_SHEDULE';
export const CLEAR_SHEDULE = 'CLEAR_SHEDULE';
export const CLEAR_SHEDULE_FLAGS = 'CLEAR_SHEDULE_FLAGS';

// Logs -----------------------------------------------------------
export const LIST_LOGS_INIT = 'LIST_LOGS_INIT';
export const LIST_LOGS_SUCCESS = 'LIST_LOGS_SUCCESS';
export const ERROR_LOGS = 'ERROR_LOGS';
export const CLEAR_LOGS = 'CLEAR_LOGS';
export const CLEAR_LOGS_FLAGS = 'CLEAR_LOGS_FLAGS';

// Chat IA -----------------------------------------------------------
export const CHAT_IA_INIT = 'CHAT_IA_INIT';
export const CHAT_IA_SUCCESS = 'CHAT_IA_SUCCESS';
export const CHAT_IA_GET_HISTORICO_INIT = 'CHAT_IA_GET_HISTORICO_INIT';
export const CHAT_IA_GET_HISTORICO_SUCCESS = 'CHAT_IA_GET_HISTORICO_SUCCESS';
export const ERROR_CHAT_IA = 'ERROR_CHAT_IA';
export const CLEAR_CHAT_IA = 'CLEAR_CHAT_IA';

// ERPs  -----------------------------------------------------------
export const LIST_ERPS_INIT = 'LIST_ERPS_INIT';
export const LIST_ERPS_SUCCESS = 'LIST_ERPS_SUCCESS';
export const CREATE_ERP_INIT = 'CREATE_ERP_INIT';
export const CREATE_ERP_SUCCESS = 'CREATE_ERP_SUCCESS';
export const UPDATE_ERP_INIT = 'UPDATE_ERP_INIT';
export const UPDATE_ERP_SUCCESS = 'UPDATE_ERP_SUCCESS';
export const DELETE_ERP_INIT = 'DELETE_ERP_INIT';
export const DELETE_ERP_SUCCESS = 'DELETE_ERP_SUCCESS';
export const ADD_ERP_VERSAO_INIT = 'ADD_ERP_VERSAO_INIT';
export const ADD_ERP_VERSAO_SUCCESS = 'ADD_ERP_VERSAO_SUCCESS';
export const ERPS_ERROR_MSG = 'ERPS_ERROR_MSG';
export const CLEAR_FLAGS_ERPS = 'CLEAR_FLAGS_ERPS';

// Variaveis Globais -----------------------------------------------------------
export const GET_VARIAVEIS_GLOBAIS_INIT = 'GET_VARIAVEIS_GLOBAIS_INIT';
export const GET_VARIAVEIS_GLOBAIS_SUCCESS = 'GET_VARIAVEIS_GLOBAIS_SUCCESS';
export const UPDATE_VARIAVEIS_GLOBAIS_INIT = 'UPDATE_VARIAVEIS_GLOBAIS_INIT';
export const UPDATE_VARIAVEIS_GLOBAIS_SUCCESS = 'UPDATE_VARIAVEIS_GLOBAIS_SUCCESS';
export const ERROR_VARIAVEIS_GLOBAIS_MSG = 'ERROR_VARIAVEIS_GLOBAIS_MSG';
export const CLEAR_FLAGS_VARIAVEIS_GLOBAIS = 'CLEAR_FLAGS_VARIAVEIS_GLOBAIS';

// Sources Globais -----------------------------------------------------------
export const GET_SOURCES_GLOBAIS_INIT = 'GET_SOURCES_GLOBAIS_INIT';
export const GET_SOURCES_GLOBAIS_SUCCESS = 'GET_SOURCES_GLOBAIS_SUCCESS';
export const UPDATE_SOURCE_GLOBAL_ATIVO_INIT = 'UPDATE_SOURCE_GLOBAL_ATIVO_INIT';
export const UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS = 'UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS';
export const ERROR_SOURCES_GLOBAIS_MSG = 'ERROR_SOURCES_GLOBAIS_MSG';
export const CLEAR_FLAGS_SOURCES_GLOBAIS = 'CLEAR_FLAGS_SOURCES_GLOBAIS';

// Variáveis -----------------------------------------------------------
export const LIST_VARIAVEIS_INIT = 'LIST_VARIAVEIS_INIT';
export const LIST_VARIAVEIS_SUCCESS = 'LIST_VARIAVEIS_SUCCESS';
export const CREATE_VARIAVEL_INIT = 'CREATE_VARIAVEL_INIT';
export const CREATE_VARIAVEL_SUCCESS = 'CREATE_VARIAVEL_SUCCESS';
export const UPDATE_VARIAVEL_INIT = 'UPDATE_VARIAVEL_INIT';
export const UPDATE_VARIAVEL_SUCCESS = 'UPDATE_VARIAVEL_SUCCESS';
export const DELETE_VARIAVEL_INIT = 'DELETE_VARIAVEL_INIT';
export const DELETE_VARIAVEL_SUCCESS = 'DELETE_VARIAVEL_SUCCESS';
export const VARIAVEIS_ERROR_MSG = 'VARIAVEIS_ERROR_MSG';
export const CLEAR_FLAGS_VARIAVEIS = 'CLEAR_FLAGS_VARIAVEIS';

// Querys -----------------------------------------------------------
export const LIST_ERP_VERSAO_QUERYS_INIT = 'LIST_ERP_VERSAO_QUERYS_INIT';
export const LIST_ERP_VERSAO_QUERYS_SUCCESS = 'LIST_ERP_VERSAO_QUERYS_SUCCESS';
export const QUERYS_ERROR_MSG = 'QUERYS_ERROR_MSG';
export const CLEAR_QUERYS = 'CLEAR_QUERYS';
export const LIST_ALL_QUERYS_INIT = 'LIST_ALL_QUERYS_INIT';
export const LIST_ALL_QUERYS_SUCCESS = 'LIST_ALL_QUERYS_SUCCESS';
export const CREATE_QUERY_INIT = 'CREATE_QUERY_INIT';
export const CREATE_QUERY_SUCCESS = 'CREATE_QUERY_SUCCESS';
export const UPDATE_QUERY_INIT = 'UPDATE_QUERY_INIT';
export const UPDATE_QUERY_SUCCESS = 'UPDATE_QUERY_SUCCESS';
export const DELETE_QUERY_INIT = 'DELETE_QUERY_INIT';
export const DELETE_QUERY_SUCCESS = 'DELETE_QUERY_SUCCESS';
export const CLEAR_FLAGS_QUERYS = 'CLEAR_FLAGS_QUERYS';

// Validação Relatórios Iqvia -----------------------------------------------------------
export const EXECUTAR_VALIDACAO_INIT_IQVIA = 'EXECUTAR_VALIDACAO_INIT_IQVIA';
export const EXECUTAR_VALIDACAO_SUCCESS_IQVIA = 'EXECUTAR_VALIDACAO_SUCCESS_IQVIA';
export const EXECUTAR_VALIDACAO_ERROR_IQVIA = 'EXECUTAR_VALIDACAO_ERROR_IQVIA';
export const BUSCA_CONSULTAS_INIT_IQVIA = 'BUSCA_CONSULTAS_INIT_IQVIA';
export const BUSCA_CONSULTAS_SUCCESS_IQVIA = 'BUSCA_CONSULTAS_SUCCESS_IQVIA';
export const BUSCA_CONSULTAS_ERROR_IQVIA = 'BUSCA_CONSULTAS_ERROR_IQVIA';
export const CLEAR_FLAGS_VALIDACAO_IQVIA = 'CLEAR_FLAGS_VALIDACAO_IQVIA';
export const CLEAR_DADOS_VALIDACAO_IQVIA = 'CLEAR_DADOS_VALIDACAO_IQVIA';

// Info Financeiras ----------------------------------------------------------------------------
export const LIST_INFO_FINANCEIRAS_INIT = 'LIST_INFO_FINANCEIRAS_INIT';
export const LIST_INFO_FINANCEIRAS_SUCCESS = 'LIST_INFO_FINANCEIRAS_SUCCESS';
export const CREATE_INFO_FINANCEIRAS_INIT = 'CREATE_INFO_FINANCEIRAS_INIT';
export const CREATE_INFO_FINANCEIRAS_SUCCESS = 'CREATE_INFO_FINANCEIRAS_SUCCESS';
export const UPDATE_INFO_FINANCEIRAS_INIT = 'UPDATE_INFO_FINANCEIRAS_INIT';
export const UPDATE_INFO_FINANCEIRAS_SUCCESS = 'UPDATE_INFO_FINANCEIRAS_SUCCESS';
export const DELETE_INFO_FINANCEIRAS_INIT = 'DELETE_INFO_FINANCEIRAS_INIT';
export const DELETE_INFO_FINANCEIRAS_SUCCESS = 'DELETE_INFO_FINANCEIRAS_SUCCESS';
export const LIST_DRES_INIT = 'LIST_DRES_INIT';
export const LIST_DRES_SUCCESS = 'LIST_DRES_SUCCESS';
export const INFO_FINANCEIRAS_ERROR_MSG = 'INFO_FINANCEIRAS_ERROR_MSG';
export const CLEAR_INFO_FINANCEIRAS = 'CLEAR_INFO_FINANCEIRAS';
